<app-nav titulo="Contratos listos para ser firmados" descripcion="Estos contratos necesitan la firma digital del corporativo para continuar.">
    <div class="digital-signatures">
        <div class="buttons">
            <button mat-raised-button class="garantor-button" color="primary" (click)="downloadAllPendingContracts()">
                Descargar todos los pendientes
            </button>
            <button mat-raised-button class="garantor-button downup-contract" color="primary" (click)="uploader.click()">
                Subir contratos firmados
            </button>
            <input #uploader class="uploader" type="file" (change)="uploadFiles($event)" multiple>
        </div>
        <app-data-table
            [rows]="guaranties"
            [columns]="columns"
            [paginatorStatus]="guarantiesPaginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateGuaranties($event)"
            (sortFn)="updateGuarantiesSort($event)"
        ></app-data-table>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-raised-button class="garantor-button mini download-contract-pdf" color="primary" (click)="downloadDocument(row.contratosContratoGarantiaId)">
            <mat-icon>download</mat-icon>
            Contrato garantía (.pdf)
        </button>
        <button mat-raised-button class="garantor-button mini download-contract-docx" color="primary" (click)="downloadDocument(row.contratosContratoGarantiaDocId)">
            <mat-icon>download</mat-icon>
            Contrato garantía (.docx)
        </button>
    </div>
</ng-template>
